/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Transaction_NoInputs */

const en_settings_credits_transaction_no = /** @type {(inputs: Settings_Credits_Transaction_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transaction`)
};

/**
* | output |
* | --- |
* | "Transaction" |
*
* @param {Settings_Credits_Transaction_NoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_credits_transaction_no = /** @type {((inputs?: Settings_Credits_Transaction_NoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Transaction_NoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_credits_transaction_no(inputs)
});
export { settings_credits_transaction_no as "settings.credits.transaction_no" }